import { CardDimension } from "@/type/core/signatory/signatory.types";
import { U2_CARD } from "@utils/Constant";
import { getCardDimension } from "@utils/helpers/signatories-helper";
import { useEffect, useRef, useState } from "react";

interface UseSignatoryCardReturn {
  width: number;
  height: number;
}

interface UseSignatoryCardProps {
  rank: number;
  pageNumber: number;
}

const useSignatoryCardDimension = ({
  rank,
  pageNumber,
}: UseSignatoryCardProps): UseSignatoryCardReturn => {
  const observerRef = useRef<MutationObserver | null>(null);

  const [pdf, setPdf] = useState<HTMLCanvasElement | null>(null);

  const [cardDimension, setCardDimension] = useState<CardDimension>();

  useEffect(() => {
    const queryPdf = document.querySelector(
      `#document_${rank} .active canvas`,
    ) as HTMLCanvasElement;

    if (queryPdf) {
      setPdf(queryPdf);
    } else {
      const observer = new MutationObserver(() => {
        const observedPdf = document.querySelector<HTMLCanvasElement>(
          `#document_${rank} .pdf .active canvas`,
        );
        if (observedPdf) {
          setPdf(observedPdf);
          observer.disconnect();
        }
      });

      observer.observe(document.body, {
        childList: true,
        subtree: true,
      });

      observerRef.current = observer;
    }

    return () => {
      observerRef.current?.disconnect();
    };
  }, [rank, pageNumber]);

  useEffect(() => {
    if (pdf && !cardDimension) {
      setCardDimension(getCardDimension(pdf));
    }
  }, [pdf]);

  return {
    width: cardDimension?.width ?? U2_CARD.cardWidth,
    height: cardDimension?.height ?? U2_CARD.cardHeight,
  };
};

export default useSignatoryCardDimension;
